import { useEffect } from 'react';
import { useBondFilterState } from '@/creditflowresearch/application/Bonds/BondsFiltersContext/useFiltersState';
import { useFilterApi } from '@/creditflowresearch/application/Bonds/BondsFiltersContext/useFilterApi';
import useBondsFilters from '@/creditflowresearch/application/Bonds/BondsFiltersContext/useBondsFilters';
import { useFilterUrl } from '@/creditflowresearch/application/hooks/useFilterUrl';
import {
  useBondsFiltersInitialisation,
} from '@/creditflowresearch/application/Bonds/BondsFiltersContext/useBondsFiltersInitialisation';
import { IBondsFilterState } from '@/creditflowresearch/domain/vo/Bond/BondsFiltersContextData';
import useMappedSectors from '@/creditflowresearch/application/HeaderMenu/useMappedSectors';
import { IQueryParams } from '@/creditflowresearch/domain/vo/IQueryParams';
import { useRouter } from '@framework/router';
import { getFilterFromSector } from '@/creditflowresearch/application/helpers';

export const useBondsFiltersData = (initial: IBondsFilterState) => {
  const sectorsList = useMappedSectors();
  const { query: { sector } }:{ query: IQueryParams } = useRouter();
  const sectorItem = sectorsList[sector];

  const {
    setIsFetching,
    setItems,
    items,
    initialFilters,
    setAppliedFilters,
    setInitialFilters,
    setFiltersPayload,
    setMinMaxDatePeriod,
    appliedFilters,
    dateFromMin,
    dateToMax,
    isFetching,
    filtersPayload,
    resetState,
  } = useBondFilterState(initial);

  const { getBondsFilter } = useFilterApi(setIsFetching, setItems);

  const { updateUrlWithParams, removeFilterParamsFromUrl } = useFilterUrl();

  const { applyFilter, fetchFilter, initBondsFilters, getFiltersPayload, resetFilters } = useBondsFilters({
    initialFilters,
    getBondsFilter,
    setAppliedFilters,
    setInitialFilters,
    setFiltersPayload,
    updateUrlWithParams,
    removeFilterParamsFromUrl,
    setMinMaxDatePeriod,
    items,
  });

  const initBonds = useBondsFiltersInitialisation({
    getFiltersPayload,
    initial,
    setFiltersPayload,
    initBondsFilters,
  });

  useEffect(() => {
    if (!sectorItem) {
      return;
    }
    setFiltersPayload((prev) => {
      const updatedSectorPayload = {
        ...prev,
        includedSectorIds: [],
        includedSubsectorIds: [],
        ...getFilterFromSector(sectorItem),
      };
      return (updatedSectorPayload);
    });
  }, [sectorItem?.sectorId, sectorItem?.subsectorId]);

  useEffect(() => () => {
    resetState();
  }, []);

  return {
    getBondsFilter,
    applyFilter,
    fetchFilter,
    initBonds,
    initialFilters,
    appliedFilters,
    dateFromMin,
    dateToMax,
    isFetching,
    items,
    setFiltersPayload,
    setAppliedFilters,
    filtersPayload,
    resetFilters,
  };
};
